import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class VoteTypeOptionsTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'VoteTypeOptionsTranslations'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      localeId: null,
      voteTypeOptionId: null,
    }
  }
}
const servicePath = 'vote-type-options-translations'
const servicePlugin = makeServicePlugin({
  Model: VoteTypeOptionsTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
